import { Ref } from 'react'

import { OperationRoomIcon } from '../../icons/OperationRoomIcon'
import { SizeOptions } from '../../types/types'
import { AstraEntityChip, EntityChipSize, EntityChipVariant } from '../AstraEntityChip/AstraEntityChip'

const OR_CHROMA = 20
const OR_LUMINANCE = 70

type Props = {
    /**
     * Short name or identifier to display (e.g., "OR1", "OR2")
     */
    shortName: string
    /**
     * Visual variant of the chip
     */
    variant?: EntityChipVariant
    /**
     * Size of the chip
     */
    size?: SizeOptions
    /**
     * data-testid for testing purposes
     */
    'data-test'?: string
    /**
     * Ref to the div element
     */
    ref?: Ref<HTMLDivElement>
}

/**
 * AstraOperationRoomChip displays a colored chip with operation room information.
 * The color is automatically generated based on the shortName using a desaturated LCH profile
 * suited for room/location entities.
 */
export const AstraLocationChip = ({ ref, shortName, variant = 'primary', size = 'small', 'data-test': dataTest = 'location-chip' }: Props) => {
    const entitySize: EntityChipSize = size === 'large' ? 'medium' : size

    return (
        <AstraEntityChip
            ref={ref}
            hideTooltip={true}
            icon={OperationRoomIcon}
            label={shortName}
            size={entitySize}
            variant={variant}
            chroma={OR_CHROMA}
            luminance={OR_LUMINANCE}
            avalanche
            data-test={dataTest}
        />
    )
}
